import { Component, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Storage } from '@ionic/storage';
import { TranslateModule } from '@ngx-translate/core'; // ✅ Add this

@Component({
  standalone: true,
  selector: 'app-home',
  host: { class: 'ion-page' },
  imports: [IonicModule, RouterModule, CommonModule, TranslateModule],
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit {
  private _storage: Storage | null = null;
  public myNotes: string[] = [];

  constructor(private storage: Storage) {}

  async ngOnInit() {
    await this.initStorage();
    await this.loadNotes();
  }

  async initStorage() {
    const storage = await this.storage.create();
    this._storage = storage;
    console.log('Ionic Storage initialized.');
  }

  async addNote(noteText: string) {
    if (!this._storage) return;

    let currentNotes = await this.loadNotes();
    currentNotes = currentNotes || [];
    currentNotes.push(noteText);

    await this._storage.set('my_app_notes', currentNotes);
    this.myNotes = currentNotes;

    console.log('Note added:', noteText);
  }

  async loadNotes(): Promise<string[]> {
    if (!this._storage) return [];
    const data = await this._storage.get('my_app_notes');
    this.myNotes = data || [];
    return this.myNotes;
  }

  async clearNotes() {
    if (!this._storage) return;
    await this._storage.remove('my_app_notes');
    this.myNotes = [];
    console.log('All notes cleared.');
  }
}
